//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// This file is autogenerated. DO NOT EDIT.
//
// To regenerate, run "make gen-cue" from the repository root.
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~


export const modelVersion = Object.freeze([0, 0]);


export interface PanelOptions {
  feedUrl?: string;
  showImage?: boolean;
}

export const defaultPanelOptions: Partial<PanelOptions> = {
  showImage: true,
};
